import Services from "../../components/Service/Services";
export default function Servicess() {
  return <Services />;
}
